import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export type HomeMatchBasicFlowGtmModalEventName = "modal_post_lead" | "modal_post_sign_up" | "modal_post_preferences";
export type HomeMatchBasicFlowGtmModalAction = "view" | "submit" | "close";
export type HomeMatchBasicFlowGtmResignationAction = "view" | "click" | "close";

interface IHomeMatchBasicFlowGtmContext {
    eventName: HomeMatchBasicFlowGtmModalEventName;
    eventCategory: string;
}

interface IHomeMatchBasicFlowModalEventParams extends IHomeMatchBasicFlowGtmContext {
    eventAction: HomeMatchBasicFlowGtmModalAction;
    homeMatchBasicConsent: boolean;
}

interface IHomeMatchBasicFlowToggleEventParams extends IHomeMatchBasicFlowGtmContext {
    isEnabled: boolean;
}

interface IHomeMatchBasicFlowResignationEventParams {
    eventAction: HomeMatchBasicFlowGtmResignationAction;
    sourceModal: HomeMatchBasicFlowGtmModalEventName;
    eventCategory: string;
    eventLabel?: string;
}

export const HOME_MATCH_BASIC_KEEP_ENABLED_LABEL = "Zostawiam dopasowanie ofert";
export const HOME_MATCH_BASIC_DISABLE_LABEL = "Wyłączam i szukam samodzielnie";

export const getHomeMatchBasicModalConsentLabel = (homeMatchBasicConsent: boolean) => (homeMatchBasicConsent ? "toggle_on" : "toggle_off");

export const hitGtmHomeMatchBasicFlowModal = (params: IHomeMatchBasicFlowModalEventParams) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: params.eventAction,
        event_label: getHomeMatchBasicModalConsentLabel(params.homeMatchBasicConsent),
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowToggle = (params: IHomeMatchBasicFlowToggleEventParams) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: "toggle_switch",
        event_label: params.isEnabled ? "on" : "off",
        custom_label: "homematch basic",
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowEditPreferences = (params: IHomeMatchBasicFlowGtmContext) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: "click",
        event_label: "Zmień",
        custom_label: "preferencje",
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowResignationModal = (params: IHomeMatchBasicFlowResignationEventParams) => {
    hitGoogleTagManager({
        event: "modal_hm_basic",
        event_action: params.eventAction,
        ...(params.eventLabel ? {event_label: params.eventLabel} : {}),
        custom_label: params.sourceModal,
        event_category: params.eventCategory
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export type HomeMatchBasicFlowGtmModalEventName = "modal_post_lead" | "modal_post_sign_up" | "modal_post_preferences";
export type HomeMatchBasicFlowGtmModalAction = "view" | "submit" | "close";
export type HomeMatchBasicFlowGtmResignationAction = "view" | "click" | "close";

interface IHomeMatchBasicFlowGtmContext {
    eventName: HomeMatchBasicFlowGtmModalEventName;
    eventCategory: string;
}

interface IHomeMatchBasicFlowModalEventParams extends IHomeMatchBasicFlowGtmContext {
    eventAction: HomeMatchBasicFlowGtmModalAction;
    homeMatchBasicConsent: boolean;
}

interface IHomeMatchBasicFlowToggleEventParams extends IHomeMatchBasicFlowGtmContext {
    isEnabled: boolean;
}

interface IHomeMatchBasicFlowResignationEventParams {
    eventAction: HomeMatchBasicFlowGtmResignationAction;
    sourceModal: HomeMatchBasicFlowGtmModalEventName;
    eventCategory: string;
    eventLabel?: string;
}

export const HOME_MATCH_BASIC_KEEP_ENABLED_LABEL = "Zostawiam dopasowanie ofert";
export const HOME_MATCH_BASIC_DISABLE_LABEL = "Wyłączam i szukam samodzielnie";

export const getHomeMatchBasicModalConsentLabel = (homeMatchBasicConsent: boolean) => (homeMatchBasicConsent ? "toggle_on" : "toggle_off");

export const hitGtmHomeMatchBasicFlowModal = (params: IHomeMatchBasicFlowModalEventParams) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: params.eventAction,
        event_label: getHomeMatchBasicModalConsentLabel(params.homeMatchBasicConsent),
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowToggle = (params: IHomeMatchBasicFlowToggleEventParams) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: "toggle_switch",
        event_label: params.isEnabled ? "on" : "off",
        custom_label: "homematch basic",
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowEditPreferences = (params: IHomeMatchBasicFlowGtmContext) => {
    hitGoogleTagManager({
        event: params.eventName,
        event_action: "click",
        event_label: "Zmień",
        custom_label: "preferencje",
        event_category: params.eventCategory
    });
};

export const hitGtmHomeMatchBasicFlowResignationModal = (params: IHomeMatchBasicFlowResignationEventParams) => {
    hitGoogleTagManager({
        event: "modal_hm_basic",
        event_action: params.eventAction,
        ...(params.eventLabel ? {event_label: params.eventLabel} : {}),
        custom_label: params.sourceModal,
        event_category: params.eventCategory
    });
};
